import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { EdPreferences, EdPreferencesApi } from '../tokens/ed-preferences.token';

/**
 * REST implementation of the E-D preferences API (PRD §O.3 / BR-ED-020, EM-843/844).
 *
 *   GET   /services/embedded/api/v1/me/preferences
 *   PATCH /services/embedded/api/v1/me/preferences  { kypOnly }
 *
 * Self-scoped server-side (Rule 22). REST-only (Rules 07/10). Bound to ED_PREFERENCES.
 */
@Injectable({ providedIn: 'root' })
export class EdPreferencesRestService implements EdPreferencesApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/me/preferences`;

  getPreferences(): Observable<EdPreferences> {
    return this.http.get<EdPreferences>(this.base);
  }

  setKypOnly(kypOnly: boolean): Observable<EdPreferences> {
    return this.http.patch<EdPreferences>(this.base, { kypOnly });
  }
}
